import styled from 'styled-components';
export var Wrap = styled.div.withConfig({
  displayName: "style__Wrap",
  componentId: "uqkx54-0"
})(["top:0;bottom:0;left:0;right:0;z-index:999;overflow-y:scroll;overflow-x:hidden;background:white;"]);